import axios from "axios"

const createApproval = (data: $TSMigrationFixMe) =>
  axios.post(`/FlujoAprobacion`, data)

const fetchAprovalList = () => axios.get(`/FlujoAprobacion/all`)

const fetchAprovalById = (id: $TSMigrationFixMe) =>
  axios.get(`/FlujoAprobacion/${id}`)

const updateApproval = (data: $TSMigrationFixMe) =>
  axios.put(`/FlujoAprobacion/${data.id}`, data)

const deleteApproval = (id: $TSMigrationFixMe) =>
  axios.delete(`/FlujoAprobacion/${id}`)

export const approvalsServices = {
  createApproval,
  fetchAprovalList,
  fetchAprovalById,
  updateApproval,
  deleteApproval,
}
